import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import { removeCookie } from '@dbh/cookies';
import { logTracking } from '@dbh/tracking-loggers';

/*
 *
 * Constants: `@dbh/tracking-microsoft-clarity`.
 *
 */const COOKIE_DOMAIN_REGEX=/^.+(daybreakhotels.+)$/;// @see {@link https://learn.microsoft.com/en-us/clarity/setup-and-installation/cookie-list}
const MICROSOFT_CLARITY_COOKIES_NAMES={CLARITY_USER_ID:"_clck",CLARITY_SESSION_ID:"_clsk"};const MICROSOFT_CLARITY_COOKIES=Object.values(MICROSOFT_CLARITY_COOKIES_NAMES);

/**
 * Removes `Microsoft Clarity` consent and cookies. In order to comply with
 * `GDPR`, if a user rejects cookies after having accepted them (even though
 * there's no way to do that with the `One Trust` bar), we need to instruct
 * `Microsoft Clarity` to stop creating new cookies.
 * @param {Object} cookies .
 * @see {@link https://clarity.microsoft.com/projects/view/l0nrcxv5sj/settings?date=Today#setup}
 * @see {@link https://clarity.microsoft.com/projects/view/l0lz4rqc51/settings?date=Last%203%20days#setup}
 * @see {@link https://learn.microsoft.com/en-us/clarity/setup-and-installation/cookie-consent#erase-cookies}
 * @see `@dbh/cookie-consent#useInjectCookieConsentCallback`.
 */const removeMicrosoftClarityCookies=withConformsTo("removeMicrosoftClarityCookies",[],a=>{const{host:b}=window.location;window.clarity&&(window.clarity("consent",!1),logTracking("[consent][clarity][denied]"));const c=a.get(MICROSOFT_CLARITY_COOKIES_NAMES.CLARITY_USER_ID);if(c){// `dev.daybreakhotels.localhost` -> `.daybreakhotels.localhost`.
// `test.daybreakhotels.com` -> `.daybreakhotels.com`.
// `www.daybreakhotels.com` -> `.daybreakhotels.com`.
// `daybreakhero.test.daybreakhotels.com` -> `.daybreakhotels.com`.
// `something.test.daybreakhotels.com` -> `.daybreakhotels.com`.
// @TODO: is this really necessary or is `window.clarity('consent', false)`
// above enough?
const[,c]=b.match(COOKIE_DOMAIN_REGEX);MICROSOFT_CLARITY_COOKIES.forEach(b=>{removeCookie(a,b,{domain:"."+c});});}});var removeMicrosoftClarityCookies$1 = removeMicrosoftClarityCookies;

/**
 * This allows the recording of sessions after rendering the landing page
 * and accepting the cookie consent inside it, with the `One Trust` bar.
 * If the user has given consent, the function `window.clarity('consent')`
 * allows `clarity` to use cookies to track the navigation as a single session.
 * Without `clarity` consent, each page navigation will be recorded as a separate
 * session. `clarity` should already be loaded when this function is called by
 * `useInjectCookieConsentCallback`, but just in case we do a check, before
 * firing the `clarity` consent granted event. When this function is called in
 * the landing page, if the `One Trust` performance cookie was found grainted by
 * `@dbh/browser-clarity`, the `clarity` consent was already fired. So this will
 * fire it again in that case, but the duplication doesn't cause issues.
 */const fireClarityConsentIfClarityIsEnabled=()=>{window.clarity&&(window.clarity("consent"),logTracking("[consent][clarity][granted]"));};var fireClarityConsentIfClarityIsEnabled$1 = fireClarityConsentIfClarityIsEnabled;

export { fireClarityConsentIfClarityIsEnabled$1 as fireClarityConsentIfClarityIsEnabled, removeMicrosoftClarityCookies$1 as removeMicrosoftClarityCookies };
